module.exports = __webpack_public_path__ + "static/media/a-precision-tool.cf8fb671.png";